import { render, staticRenderFns } from "./bidApply.vue?vue&type=template&id=8fd4b1de&scoped=true&lang=pug"
import script from "./bidApply.vue?vue&type=script&lang=js"
export * from "./bidApply.vue?vue&type=script&lang=js"
import style0 from "./bidApply.vue?vue&type=style&index=0&id=8fd4b1de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd4b1de",
  null
  
)

export default component.exports